import createRouter from "./createRouter";
import PersonnelContainer from "@/views/Personnel/PersonnelContainer.vue";

export const routes = [
  {
    path: '/personnel',
    component: PersonnelContainer,
    redirect: '/personnel/leave-list',
    children: [
      {
        path: '/personnel/punch-card',
        name: 'PunchCard',
        component: () => import('@/views/Personnel/Attendance/PunchCard.vue'),
        meta: {
          title: '考勤打卡'
        }
      },
      {
        path: '/personnel/attendance-calendar',
        name: 'AttendanceCalendar',
        component: () => import('@/views/Personnel/Attendance/AttendanceCalendar.vue'),
        meta: {
          title: '考勤日历'
        },
      },
      {
        path: '/personnel/attendance-list',
        name: 'AttendanceList',
        component: () => import('@/views/Personnel/Attendance/AttendanceView.vue'),
        meta: {
          title: '我的考勤'
        },
      },
      {
        path: '/personnel/attendance-org-list',
        name: 'AttendanceOrgList',
        component: () => import('@/views/Personnel/Attendance/AttendanceOrgView.vue'),
        meta: {
          title: '部门考勤'
        },
      },
      {
        path: '/personnel/attendance-org-user-calendar',
        name: 'AttendanceOrgUserCalendar',
        component: () => import('@/views/Personnel/Attendance/AttendanceOrgUserCalendar.vue'),
        meta: {
          title: '部门人员考勤日历'
        },
      },
      {
        path: '/personnel/attendance-appeal-list',
        name: 'AttendanceAppealList',
        component: () => import('@/views/Personnel/Attendance/AppealListView.vue'),
        meta: {
          title: '我的申诉'
        },
      },
      {
        path: '/personnel/appeal-detail',
        name: 'AppealDetail',
        component: () => import('@/views/Personnel/Attendance/AppealDetail.vue'),
        meta: {
          title: '申诉详情'
        },
      },
      {
        path: 'leave-list',
        name: 'LeaveList',
        component: () => import('@/views/Personnel/Leave/LeaveListView.vue'),
        meta: {
          title: '我的休假'
        },
      },
      {
        path: 'mobile-leave-list',
        name: 'MobileLeaveList',
        component: () => import('@/views/Personnel/Leave/MobileLeaveList.vue'),
        meta: {
          title: '我的休假'
        },
      },
      {
        path: 'leave-org-list',
        name: 'LeaveOrgList',
        component: () => import('@/views/Personnel/Leave/LeaveOrgListView.vue'),
        meta: {
          title: '单位休假'
        },
      },
      {
        path: 'leave-dep-list',
        name: 'LeaveDepList',
        component: () => import('@/views/Personnel/Leave/LeaveDepartmentView.vue'),
        meta: {
          title: '部门休假'
        },
      },
      {
        path: '/personnel/leave-apply',
        name: 'LeaveApply',
        component: () => import('@/views/Personnel/Leave/LeaveApply.vue'),
        meta: {
          title: '申请休假'
        }
      },
      {
        path: '/personnel/cancel-leave-list',
        name: 'CancelLeaveList',
        component: () => import('@/views/Personnel/Leave/CancelLeaveView.vue'),
        meta: {
          title: '我的销假'
        },
      },
      {
        path: '/personnel/leave-detail/:id',
        name: 'LeaveDetail',
        component: () => import('@/views/Personnel/Leave/LeaveDetail.vue'),
        meta: {
          title: '休假详情'
        }
      },
      {
        path: '/personnel/leave-detail',
        name: 'DocLeaveDetail',
        component: () => import('@/views/Personnel/Leave/LeaveDetail.vue'),
        meta: {
          title: '待办休假详情'
        }
      },
      {
        path: '/personnel/cancel-leave-form/:id',
        name: 'CancelLeaveForm',
        component: () => import('@/views/Personnel/Leave/CancelLeaveForm.vue'),
        meta: {
          title: '销假申请'
        }
      },
      {
        path: '/personnel/cancel-leave-detail/:id',
        name: 'CancelLeaveDetail',
        component: () => import('@/views/Personnel/Leave/CancelLeaveDetail.vue'),
        meta: {
          title: '销假详情'
        }
      },
      {
        path: '/personnel/cancel-leave-detail',
        name: 'DocCancelLeaveDetail',
        component: () => import('@/views/Personnel/Leave/CancelLeaveDetail.vue'),
        meta: {
          title: '待办销假详情'
        }
      },
      {
        path: '/personnel/configuration',
        name: 'ConfigurationView',
        component: () => import('@/views/Personnel/Configuration/ConfigurationView.vue'),
        meta: {
          title: '基本配置'
        }
      },
      {
        path: '/personnel/attendance-config',
        name: 'AttendanceConfig',
        component: () => import('@/views/Personnel/Configuration/AttendanceConfig.vue'),
        meta: {
          title: '考勤设置'
        }
      },
      {
        path: '/personnel/holiday-config',
        name: 'HolidayConfig',
        component: () => import('@/views/Personnel/Configuration/HolidayConfig.vue'),
        meta: {
          title: '节假日配置'
        }
      },
      {
        path: '/personnel/leave-type-list',
        name: 'LeaveTypeList',
        component: () => import('@/views/Personnel/Configuration/LeaveTypeView.vue'),
        meta: {
          title: '请假类型列表'
        }
      },
      {
        path: '/personnel/out-report-list',
        name: 'OutReportList',
        component: () => import('@/views/Personnel/OutReport/OutReportView.vue'),
        meta: {
          title: '我的报备'
        }
      },
      {
        path: '/personnel/out-report-form',
        name: 'OutReportForm',
        component: () => import('@/views/Personnel/OutReport/OutReportForm.vue'),
        meta: {
          title: '申请外出'
        }
      },
      {
        path: '/personnel/out-report-detail/:id',
        name: 'OutReportDetail',
        component: () => import('@/views/Personnel/OutReport/OutReportDetail.vue'),
        meta: {
          title: '外出详情'
        }
      },
      {
        path: '/personnel/out-report-detail',
        name: 'DocOutReportDetail',
        component: () => import('@/views/Personnel/OutReport/OutReportDetail.vue'),
        meta: {
          title: '外出详情'
        }
      },
      {
        path: '/personnel/out-report-org-list',
        name: 'OutReportOrgList',
        component: () => import('@/views/Personnel/OutReport/OutReportOrgView.vue'),
        meta: {
          title: '单位外出报备'
        }
      },
      {
        path: '/personnel/annual-leave-org-list',
        name: 'AnnualLeaveOrgList',
        component: () => import('@/views/Personnel/Configuration/AnnualLeaveOrgView.vue'),
        meta: {
          title: '单位年休假'
        }
      },
      {
        path: '/personnel/annual-leave-form',
        name: 'AnnualLeaveForm',
        component: () => import('@/views/Personnel/Configuration/AnnualLeaveForm.vue'),
        meta: {
          title: '新增年休假'
        }
      },
      {
        path: '/personnel/annual-leave-edit/:id',
        name: 'AnnualLeaveEdit',
        component: () => import('@/views/Personnel/Configuration/AnnualLeaveEdit.vue'),
        meta: {
          title: '编辑年休假'
        }
      },
      {
        path: '/personnel/annual-leave-detail/:id',
        name: 'AnnualLeaveDetail',
        component: () => import('@/views/Personnel/Configuration/AnnualLeaveDetail.vue'),
        meta: {
          title: '年休假详情'
        }
      }
    ]
  }
]

export default createRouter(routes);